"use client";

import { WHATSAPP_BUTTON_WHITELISTED_ROUTES } from "@/utils/constants/constants";
import { CONTACT_PHONE_NUMBER, WHATSAPP_DEFAULT_MESSAGE } from "@/utils/constants/project-details";
import { usePathname } from "next/navigation";
import { RainbowButton } from "../magicui/rainbow-button";
import { WhatsAppIcon } from "./social-icons";
export default function WhatsAppFloatingButton() {
  const pathname = usePathname();
  const canBeShown = WHATSAPP_BUTTON_WHITELISTED_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));
  if (!canBeShown) return null;
  const urlEncodedMessageText = encodeURIComponent(WHATSAPP_DEFAULT_MESSAGE);
  return <RainbowButton className="fixed bottom-6 right-6 z-50 h-auto rounded-full py-2 pl-5 pr-6" data-sentry-element="RainbowButton" data-sentry-component="WhatsAppFloatingButton" data-sentry-source-file="whatsapp-floating-button.tsx">
      <a href={`https://wa.me/${CONTACT_PHONE_NUMBER.replace("+", "")}?text=${urlEncodedMessageText}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
        <WhatsAppIcon size={18} className="fill-background" data-sentry-element="WhatsAppIcon" data-sentry-source-file="whatsapp-floating-button.tsx" />
        <span className="text-base">Chat</span>
      </a>
    </RainbowButton>;
}

// Recycled

// <div className="fixed bottom-6 right-6 z-50 rounded-full bg-[#25d366] px-4 py-2 text-sm shadow-lg transition-all hover:bg-opacity-90">